@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.reminders.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.reminders.generated.resources/"

internal val Res.string.feature_reminders_card_summary_many: StringResource by lazy {
      StringResource("string:feature_reminders_card_summary_many", "feature_reminders_card_summary_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 71),
      ))
    }

internal val Res.string.feature_reminders_card_summary_one: StringResource by lazy {
      StringResource("string:feature_reminders_card_summary_one", "feature_reminders_card_summary_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82, 66),
      ))
    }

internal val Res.string.feature_reminders_confirm_cancel: StringResource by lazy {
      StringResource("string:feature_reminders_confirm_cancel", "feature_reminders_confirm_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149, 52),
      ))
    }

internal val Res.string.feature_reminders_confirm_open: StringResource by lazy {
      StringResource("string:feature_reminders_confirm_open", "feature_reminders_confirm_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202, 58),
      ))
    }

internal val Res.string.feature_reminders_confirm_title: StringResource by lazy {
      StringResource("string:feature_reminders_confirm_title", "feature_reminders_confirm_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 261, 71),
      ))
    }

internal val Res.string.feature_reminders_dashboard_badge_template: StringResource by lazy {
      StringResource("string:feature_reminders_dashboard_badge_template", "feature_reminders_dashboard_badge_template", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333, 90),
      ))
    }

internal val Res.string.feature_reminders_empty_state: StringResource by lazy {
      StringResource("string:feature_reminders_empty_state", "feature_reminders_empty_state", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 424, 81),
      ))
    }

internal val Res.string.feature_reminders_error_launch_failed: StringResource by lazy {
      StringResource("string:feature_reminders_error_launch_failed", "feature_reminders_error_launch_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 506, 81),
      ))
    }

internal val Res.string.feature_reminders_error_load_failed: StringResource by lazy {
      StringResource("string:feature_reminders_error_load_failed", "feature_reminders_error_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 588, 95),
      ))
    }

internal val Res.string.feature_reminders_error_record_failed: StringResource by lazy {
      StringResource("string:feature_reminders_error_record_failed", "feature_reminders_error_record_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 684, 85),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_button: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_button", "feature_reminders_mark_paid_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 770, 66),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_cancel: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_cancel", "feature_reminders_mark_paid_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 837, 54),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_confirm: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_confirm", "feature_reminders_mark_paid_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 892, 55),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_error: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_error", "feature_reminders_mark_paid_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 948, 89),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_method_label: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_method_label", "feature_reminders_mark_paid_method_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1038, 68),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_sessions_label: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_sessions_label", "feature_reminders_mark_paid_sessions_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1107, 74),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_success_many: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_success_many", "feature_reminders_mark_paid_success_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1182, 80),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_success_one: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_success_one", "feature_reminders_mark_paid_success_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1263, 71),
      ))
    }

internal val Res.string.feature_reminders_mark_paid_title: StringResource by lazy {
      StringResource("string:feature_reminders_mark_paid_title", "feature_reminders_mark_paid_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1335, 65),
      ))
    }

internal val Res.string.feature_reminders_method_cash: StringResource by lazy {
      StringResource("string:feature_reminders_method_cash", "feature_reminders_method_cash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1401, 49),
      ))
    }

internal val Res.string.feature_reminders_method_mercadopago: StringResource by lazy {
      StringResource("string:feature_reminders_method_mercadopago", "feature_reminders_method_mercadopago", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1451, 60),
      ))
    }

internal val Res.string.feature_reminders_method_transfer: StringResource by lazy {
      StringResource("string:feature_reminders_method_transfer", "feature_reminders_method_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1512, 61),
      ))
    }

internal val Res.string.feature_reminders_pause_button: StringResource by lazy {
      StringResource("string:feature_reminders_pause_button", "feature_reminders_pause_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 66),
      ))
    }

internal val Res.string.feature_reminders_send_button: StringResource by lazy {
      StringResource("string:feature_reminders_send_button", "feature_reminders_send_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1641, 65),
      ))
    }

internal val Res.string.feature_reminders_sent_success: StringResource by lazy {
      StringResource("string:feature_reminders_sent_success", "feature_reminders_sent_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1819, 66),
      ))
    }

internal val Res.string.feature_reminders_sent_success_not_recorded: StringResource by lazy {
      StringResource("string:feature_reminders_sent_success_not_recorded", "feature_reminders_sent_success_not_recorded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1707, 111),
      ))
    }

internal val Res.string.feature_reminders_title: StringResource by lazy {
      StringResource("string:feature_reminders_title", "feature_reminders_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1886, 51),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_reminders_card_summary_many", Res.string.feature_reminders_card_summary_many)
  map.put("feature_reminders_card_summary_one", Res.string.feature_reminders_card_summary_one)
  map.put("feature_reminders_confirm_cancel", Res.string.feature_reminders_confirm_cancel)
  map.put("feature_reminders_confirm_open", Res.string.feature_reminders_confirm_open)
  map.put("feature_reminders_confirm_title", Res.string.feature_reminders_confirm_title)
  map.put("feature_reminders_dashboard_badge_template", Res.string.feature_reminders_dashboard_badge_template)
  map.put("feature_reminders_empty_state", Res.string.feature_reminders_empty_state)
  map.put("feature_reminders_error_launch_failed", Res.string.feature_reminders_error_launch_failed)
  map.put("feature_reminders_error_load_failed", Res.string.feature_reminders_error_load_failed)
  map.put("feature_reminders_error_record_failed", Res.string.feature_reminders_error_record_failed)
  map.put("feature_reminders_mark_paid_button", Res.string.feature_reminders_mark_paid_button)
  map.put("feature_reminders_mark_paid_cancel", Res.string.feature_reminders_mark_paid_cancel)
  map.put("feature_reminders_mark_paid_confirm", Res.string.feature_reminders_mark_paid_confirm)
  map.put("feature_reminders_mark_paid_error", Res.string.feature_reminders_mark_paid_error)
  map.put("feature_reminders_mark_paid_method_label", Res.string.feature_reminders_mark_paid_method_label)
  map.put("feature_reminders_mark_paid_sessions_label", Res.string.feature_reminders_mark_paid_sessions_label)
  map.put("feature_reminders_mark_paid_success_many", Res.string.feature_reminders_mark_paid_success_many)
  map.put("feature_reminders_mark_paid_success_one", Res.string.feature_reminders_mark_paid_success_one)
  map.put("feature_reminders_mark_paid_title", Res.string.feature_reminders_mark_paid_title)
  map.put("feature_reminders_method_cash", Res.string.feature_reminders_method_cash)
  map.put("feature_reminders_method_mercadopago", Res.string.feature_reminders_method_mercadopago)
  map.put("feature_reminders_method_transfer", Res.string.feature_reminders_method_transfer)
  map.put("feature_reminders_pause_button", Res.string.feature_reminders_pause_button)
  map.put("feature_reminders_send_button", Res.string.feature_reminders_send_button)
  map.put("feature_reminders_sent_success", Res.string.feature_reminders_sent_success)
  map.put("feature_reminders_sent_success_not_recorded", Res.string.feature_reminders_sent_success_not_recorded)
  map.put("feature_reminders_title", Res.string.feature_reminders_title)
}
